/* eslint-disable max-len */
import { Component, Input, OnInit, Output } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { EventV2Dto, MachineRestService, MachineV2Dto } from 'src/app/api/exa';
import { LocationStatusItem } from 'src/app/model/location-status-item';
import { MachineState } from 'src/app/pages/map/map.page';
import { AlertService } from 'src/app/services/alert.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { ImplementService } from 'src/app/services/implement.service';
import { MachineService } from 'src/app/services/machine.service';

@Component({
  selector: 'drawer-content-machine-info',
  templateUrl: './machine-info.component.html',
  styleUrls: ['./machine-info.component.scss'],
})
export class MachineInfoComponent implements OnInit {
  @Input('machine-state') machineState: MachineState;
  @Input('machinePathLength') machinePathLength: number;

  @Output('machineTracksVisibility') machineTracksVisibility: boolean;

  googleMapsUrl: string;

  latitude = null;
  longitude = null;

  selectMachinePathLength = 240;
  machineGpsPosition: MachineStatusItem[] = [];
  machinesGpsPath: LocationStatusItem[][] = [];
  checkBoxPathValues: boolean[] = [];
  machineStates: MachineStatusItem[] = [];
  eventsDto: EventV2Dto[] = [];

  constructor(
    public toastController: ToastController,
    private alertService: AlertService,
    private machineService: MachineService,
    private machineRestService: MachineRestService,
    private implementService: ImplementService,
    private employeeService: EmployeeService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    console.log(' machine state: ', this.machineState);
    console.log(' show machine tracks: ', this.machineState.pathVisible);
  }

  getSizeOfBarValues(): number {
    if (this.hasGrainTank()) {
      return 3;
    }
    return 4;
  }

  getMachineName(): string {
    return this.machineService.getFormattedName(this.machineState.machine);
  }

  getStatusUpdateTime(machine) {
    // console.log(machine);
    if (machine.currentLocation) {
      return machine.currentLocation.t;
    }
    if (machine.currentAdapterState) {
      return machine.currentAdapterState.t;
    }
    return machine.lastPosition.time;
  }

  hasImplement(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.iId) {
      return true;
    }
    return false;
  }

  getImplementName(): string {
    return this.implementService.getFormattedNameById(this.machineState.currentLocation.iId);
  }

  hasDriver(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.dU) {
      return true;
    }
    return false;
  }

  getDriverName(): string {
    return this.employeeService.getFormattedNameByUsername(this.machineState.currentLocation.dU);
  }

  hasSpeed(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.sp != null) {
      return true;
    }
    return false;
  }

  getSpeedPercentage(): number {
    // 90km/h = 100%  /  90km/h = 25m/s
    const maxSpeed = 25;
    return this.machineState.currentLocation.sp / maxSpeed;
  }

  hasFuelTank(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.ftl != null) {
      return true;
    }
    return false;
  }

  getFuelTankPercentage(): number {
    return this.machineState.currentLocation.ftl / 100;
  }

  hasAdBlue(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.atl != null) {
      return true;
    }
    return false;
  }

  getAdBluePercentage(): number {
    return this.machineState.currentLocation.atl / 100;
  }

  hasGrainTank(): boolean {
    if (this.machineState && this.machineState.currentLocation && this.machineState.currentLocation.gtl != null) {
      return true;
    }
    return false;
  }

  getGrainTankPercentage(): number {
    return this.machineState.currentLocation.gtl / 100;
  }

  onToggleShowMachineTracks() {
    this.machineState.pathVisible = !this.machineState.pathVisible;
    console.log(' machine State: ', this.machineState);
  }

  onClickReloadMachineTracks($event, machineId: number) {
    $event.stopPropagation();
    const positionsFrom = new Date().getTime() - this.machinePathLength * 60 * 1000;
    const machine = this.machineState;
    if (machine.currentLocation.lat && machine.currentLocation.lng) {
      const locStatItem = machine.currentLocation;
      if (locStatItem.t >= positionsFrom) {
        // was online in desired time frame
        this.machineRestService.getMachinePositionsUsingGET(positionsFrom.toString(), machine.machine.id).subscribe(
          (machinePositions) => {
            // append all historic GPS positions to the machine information
            let machineLocationsStati = [];
            for (const machPos of machinePositions) {
              const locStatItem = {
                mId: machineId,
                t: machPos.time,
                lat: machPos.latitude,
                lng: machPos.longitude,
              };
              machineLocationsStati.push(locStatItem);
            }

            if (machineLocationsStati.length > 0) {
              let maxTime = 0;
              // get machine last known point
              const locStatItem = {
                mId: machineId,
                t: this.machineState.currentLocation.t,
                lat: this.machineState.currentLocation.lat,
                lng: this.machineState.currentLocation.lng,
              };
              machineLocationsStati.push(locStatItem);
              if (maxTime < this.machineState.currentLocation.t) {
                maxTime = this.machineState.currentLocation.t;
              }
              //sort machine locations by asc time
              machineLocationsStati = machineLocationsStati.sort((n1, n2) => {
                if (n1.t > n2.t) {
                  return 1;
                }

                if (n1.t < n2.t) {
                  return -1;
                }

                return 0;
              });

              // get the current data set and add all status updates to the new set -> no loss or jump in coordinates in case the newest data points are not uploaded yet
              const locationsOLD = this.machineState.locations; // test . kann sein dass das hier das ganz falsche ist
              for (const location of locationsOLD) {
                if (location.t > maxTime) {
                  machineLocationsStati.push(location);
                }
              }
              this.machineState.locations = machineLocationsStati;
            }
          },
          (err) => {
            console.error('Position reload machine ', err);
            this.alertService.openAlertToast(this.translate.instant('DASHBOARD.MACHINE_POSITIONS.LOAD.FAILURE'), 2000);
          }
        );
      } else {
      }
    }
  }

  onClickPosition() {
    const machine = this.machineState;

    if (machine.currentLocation) {
      this.latitude = machine.currentLocation.lat;
      this.longitude = machine.currentLocation.lng;
    } else {
      this.latitude = machine.machine.lastPosition.latitude;
      this.longitude = machine.machine.lastPosition.longitude;
    }

    this.googleMapsUrl = encodeURI(
      `https://www.google.com/maps/dir/?api=1&destination=${this.latitude}+${this.longitude}&travelmode=driving`
    );

    // Use this if you want direct navigation without preview
    // window.open('google.navigation:q='+ this.latitude + ',' + this.longitude);

    //Use this if you want a route preview before start the driving
    window.open(encodeURI(this.googleMapsUrl), '_system');
  }

  async onSpeedClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('SPEED'),
      duration: 1000,
    });
    toast.present();
  }

  async onFuelTankClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('ENUM.CAN_IDENTIFIER.ENG_FueLev'),
      duration: 1000,
    });
    toast.present();
  }

  async onAdBlueClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('ADBLUE.LEVEL'),
      duration: 1000,
    });
    toast.present();
  }

  async onGrainTankClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('ENUM.CAN_IDENTIFIER.GrainTnk_Lev'),
      duration: 1000,
    });
    toast.present();
  }

  async onAdapterSerialClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('SERIAL'),
      duration: 1000,
    });
    toast.present();
  }

  async onFirmwareClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('FIRMWARE_VERSION'),
      duration: 1000,
    });
    toast.present();
  }

  async onGPSStatusClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('GPS.STATUS'),
      duration: 1000,
    });
    toast.present();
  }

  async onCANStatusClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('CAN.STATUS'),
      duration: 1000,
    });
    toast.present();
  }

  async onTCStatusClick() {
    const toast = await this.toastController.create({
      message: this.translate.instant('TC'),
      duration: 1000,
    });
    toast.present();
  }

  onClickToggelOneFahrspuren(machineId: number) {
    this.checkBoxPathValues[machineId] = !this.checkBoxPathValues[machineId];
    // this.storeCachedData('checkBoxPathValues', this.checkBoxPathValues);
    this.updateMachineGpsPaths();
  }

  centerOnMachine(e, machineId: number) {
    // const state: MachineState;
    const checked = e.detail.checked;
    console.log(e.detail.checked);
    console.log(machineId);
    if (machineId && checked === true) {
      console.log('center on machine');
      console.log(this.machineState.currentLocation.lat);
      console.log(this.machineState.currentLocation.lng);
      // const sub = state.subscribe();
    } else {
      console.log('Finish center on machine');
    }
  }

  updateEventTimeOuts() {
    const events: EventV2Dto[] = [];
    this.eventsDto.forEach((event) => {
      if (new Date().getTime() / 1000 - new Date(event.time).getTime() / 1000 < 7200) {
        events.push(event);
      }
    });
    this.eventsDto = events;
  }

  private updateMachineGpsPaths() {
    // update the model for the map
    const tmp = [];
    for (const machineGps of this.machineGpsPosition) {
      const locations = this.getMachineLocationStates(machineGps.machine.id);
      // show only the selected length
      const tmpLocations = [];
      for (const loc of locations) {
        const seconds1 = loc.t;
        const seconds2 = new Date().getTime() - this.selectMachinePathLength * 60 * 1000;
        // for test reduce the time to seconds
        // let seconds2 = (new Date().getTime() / 1000) - this.selectMachinePathLength / 10;
        if (seconds1 > seconds2 && loc.lat && loc.lng) {
          tmpLocations.push(loc);
        }
      }
      if (this.checkBoxPathValues[machineGps.machine.id]) {
        tmp.push(tmpLocations);
      }
      this.storeMachineLocationStatesforPath(machineGps.machine.id, tmpLocations);
    }
    this.machinesGpsPath = tmp;
    this.updateEventTimeOuts();
  }

  // private updateMachinesGpsPosition() {
  //   // update gps
  //   const gpsTmp = [];
  //   for (const machine of this.machineStates) {
  //     if (machine.status.lat && machine.status.lng) {
  //       gpsTmp.push(machine);
  //     }
  //   }
  //   this.machineGpsPosition = gpsTmp;
  // }

  private getMachineLocationStates(machineId: number): LocationStatusItem[] {
    const key = this.getMachineLocationStates(machineId);
    return key;
  }

  private storeMachineLocationStatesforPath(machineid: number, states: LocationStatusItem[]) {
    const key = this.getMachineLocationStates(machineid);
    return key;
  }
}
export class MachineStatusItem {
  machine: MachineV2Dto;
  status: LocationStatusItem;
  isOffline: boolean;
}
